const C = {
  name: "Growth",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
      <path d="M20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0ZM20 26C16.6863 26 14 28.6863 14 32C14 35.3137 16.6863 38 20 38C23.3137 38 26 35.3137 26 32C26 28.6863 23.3137 26 20 26ZM20 14C13.3726 14 8 19.3726 8 26C8 29.9655 9.92473 33.4802 12.8896 35.665C12.3224 34.5668 12 33.3213 12 32C12 27.5817 15.5817 24 20 24C24.4183 24 28 27.5817 28 32C28 33.3215 27.6768 34.5667 27.1094 35.665C30.0747 33.4802 32 29.9658 32 26C32 19.3726 26.6274 14 20 14ZM20 2C10.0589 2 2 10.0589 2 20C2 25.4655 4.43685 30.3609 8.28223 33.6621C6.83975 31.4606 6 28.8286 6 26C6 18.268 12.268 12 20 12C27.732 12 34 18.268 34 26C34 28.8287 33.1595 31.4605 31.7168 33.6621C35.5625 30.3609 38 25.4657 38 20C38 10.0589 29.9411 2 20 2Z" fill="currentColor"/>
    </g>
  `
};
export {
  C as Growth
};
